import type { CSSProperties } from 'react';

type AtlasFrameRect = { x: number; y: number; w: number; h: number };

export type SkyxMenuAtlasJson = {
  frames: Record<
    string,
    {
      frame: AtlasFrameRect;
      rotated?: boolean;
      sourceSize?: { w: number; h: number };
    }
  >;
  meta: {
    image: string;
    size: { w: number; h: number };
  };
};

export function resolveSkyxMenuAtlasImageUrl(
  atlasJsonUrl: string,
  metaImage: string
): string {
  const base = atlasJsonUrl.replace(/[^/]+$/, '');
  return `${base}${metaImage}`;
}

/** CSS background slice for a single TexturePacker frame. */
export function buildSkyxMenuAtlasFrameStyle(
  atlas: SkyxMenuAtlasJson,
  frameName: string,
  atlasImageUrl: string,
  displayWidthPx: number
): CSSProperties | null {
  const entry = atlas.frames[frameName];
  if (!entry) {
    return null;
  }

  const { x, y, w, h } = entry.frame;
  const rotated = entry.rotated === true;
  const sourceW = entry.sourceSize?.w ?? w;
  const sourceH = entry.sourceSize?.h ?? h;
  const { w: atlasW, h: atlasH } = atlas.meta.size;
  const scale = displayWidthPx / sourceW;
  const displayHeightPx = Math.round(sourceH * scale);

  const style: CSSProperties = {
    display: 'inline-block',
    width: `${displayWidthPx}px`,
    height: `${displayHeightPx}px`,
    backgroundImage: `url("${atlasImageUrl}")`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: `${atlasW * scale}px ${atlasH * scale}px`,
    backgroundPosition: `-${x * scale}px -${y * scale}px`,
  };

  if (rotated) {
    style.transform = 'rotate(-90deg)';
    style.transformOrigin = 'center center';
  }

  return style;
}
